import React, { useState, useEffect } from 'react';
import { useLocation,Link } from 'react-router-dom';
import logoDark from '../assets/logo.svg';
import Menu from './Menu';
import menu from '../assets/icns/menu.svg';


const Header = ({ }) => {

  // const logoSrc = isDarkBackground ? logoDark : logoDark ;
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [showMenuIcon, setShowMenuIcon] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = isOpen ? 'auto' : 'hidden';
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      if (scrollPosition > windowHeight * 0.3) {
        setShowMenuIcon(true);
      } else {
        setShowMenuIcon(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <header className="w-100 align-items-start mx-auto position-absolute z-0">
      <Menu isOpen={isOpen} closeMenu={toggleMenu} />
        <div className={`pointer menu-icon-container m-3 p-3 ${showMenuIcon ? 'fixed' : 'd-none'}`} onClick={toggleMenu}>
          <img src={menu} alt="menu" width="25px" height="auto" />
            </div>
        
        <div className='bg-gray-1000 py-2 ps-3 d-flex flex-column'>
            <p className="text-light d-md-inline fs-1rem fw-bold px-3">Paz Roth
              <span className="fw-light"> &nbsp; Art director, animator and developer</span></p>
                </div>

        <div className='d-flex w-100 justify-content-between p-3'>
          <div className="logo-container d-flex align-items-top">
            <Link to="/" className="px-2">
              <img src={logoDark} alt="Logo" className="" style={{ width: "140px" }} />
                </Link>
          </div>

          <div className="d-flex p-3 gap-5">
            <Link to="/works">
              <p className="d-none d-md-inline fw-400 fs-5 text-dark">Works</p>
                </Link>
            <Link to="/contact">
              <p className="d-none d-md-inline fw-400 fs-5 text-dark">Get Quote</p>
                </Link>

            <div onClick={toggleMenu} className='pointer'>
              <img src={menu} alt="menu" width="25" height="auto" />
                </div>
          </div>
        </div>
    </header>
  );
    }
  
  export default Header;
  